import { render, staticRenderFns } from "./QLAutisti.vue?vue&type=template&id=0c4e6275&scoped=true&"
import script from "./QLAutisti.vue?vue&type=script&lang=js&"
export * from "./QLAutisti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4e6275",
  null
  
)

export default component.exports